import { render, staticRenderFns } from "./CoverPage.vue?vue&type=template&id=0c0217bc&scoped=true"
import script from "./CoverPage.vue?vue&type=script&lang=ts"
export * from "./CoverPage.vue?vue&type=script&lang=ts"
import style0 from "./CoverPage.vue?vue&type=style&index=0&id=0c0217bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0217bc",
  null
  
)

export default component.exports